import React from 'react';

import s from './blog_text.module.scss';

export default function BlogText({ text }) {
  return <div className={s.root} dangerouslySetInnerHTML={{ __html: text }} />;
}
